export default "__VITE_ASSET__DkahWt6___"